/*
 * Copyright (c) 2019 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('privacy', {
            parent: 'app',
            url: '/privacy',
            data: {
                authorities: [],
                pageTitle: "home.privacy.title"
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/privacy.html',
                    controller: 'PrivacyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
